export { default } from './ContactUsQrView';



// WEBPACK FOOTER //
// ./src/components/views/ContactUsQrView/index.js